export default function Broadcast(props) {
  return <h1>Broadcast</h1>;
}
